import { apiRequest } from '@/calls/helpers';
// import { modifyDate, dateToStr, setTimeoutToDate } from '@/helpers/helpers';

const emailLogin = async (data) => apiRequest('session/account_login', {
  method: 'POST',
  body: data
});

const facebookLogin = async (data) => apiRequest('session/account_facebook_login', {
  method: 'POST',
  body: data
});

export {
  // eslint-disable-next-line
  emailLogin,
  facebookLogin,
};
